// Background Style Plugin
import { createColorProperty } from './helpers.js';

export default {
    id: 'background',
    label: 'Background',
    icon: 'Paint',
    properties: {
        backgroundColor: {
            label: 'Color',
            type: 'color',
            default: null,
            ...createColorProperty('bg', ['fixed', 'local', 'scroll', 'cover', 'contain', 'auto',
                'center', 'top', 'right', 'bottom', 'left', 'repeat', 'no-repeat', 'repeat-x', 'repeat-y'])
        },
        backgroundImage: {
            label: 'Image',
            type: 'select',
            options: ['none', 'gradient-to-t', 'gradient-to-tr', 'gradient-to-r', 'gradient-to-br',
                     'gradient-to-b', 'gradient-to-bl', 'gradient-to-l', 'gradient-to-tl'],
            default: null,
            toClass: (value) => value ? `bg-${value}` : null,
            fromClass: (className) => {
                const match = className.match(/^bg-(gradient-to-.+)$/);
                return match ? match[1] : null;
            }
        },
        backgroundSize: {
            label: 'Size',
            type: 'select',
            options: ['auto', 'cover', 'contain'],
            default: 'cover',
            toClass: (value) => value ? `bg-${value}` : null,
            fromClass: (className) => {
                const match = className.match(/^bg-(auto|cover|contain)$/);
                return match ? match[1] : null;
            }
        },
        backgroundPosition: {
            label: 'Position',
            type: 'select',
            options: ['center', 'top', 'top-right', 'right', 'bottom-right', 'bottom', 'bottom-left', 'left', 'top-left'],
            default: 'center',
            toClass: (value) => value ? `bg-${value}` : null,
            fromClass: (className) => {
                const match = className.match(/^bg-(center|top|top-right|right|bottom-right|bottom|bottom-left|left|top-left)$/);
                return match ? match[1] : null;
            }
        },
        backgroundRepeat: {
            label: 'Repeat',
            type: 'select',
            options: ['repeat', 'no-repeat', 'repeat-x', 'repeat-y', 'repeat-round', 'repeat-space'],
            default: 'no-repeat',
            toClass: (value) => value ? `bg-${value}` : null,
            fromClass: (className) => {
                const match = className.match(/^bg-(repeat|no-repeat|repeat-x|repeat-y|repeat-round|repeat-space)$/);
                return match ? match[1] : null;
            }
        },
        backgroundAttachment: {
            label: 'Attachment',
            type: 'select',
            options: ['fixed', 'local', 'scroll'],
            default: 'scroll',
            toClass: (value) => value ? `bg-${value}` : null,
            fromClass: (className) => {
                const match = className.match(/^bg-(fixed|local|scroll)$/);
                return match ? match[1] : null;
            }
        },
        backgroundClip: {
            label: 'Clip',
            type: 'select',
            options: ['border', 'padding', 'content', 'text'],
            default: 'border',
            toClass: (value) => value ? `bg-clip-${value}` : null,
            fromClass: (className) => {
                const match = className.match(/^bg-clip-(.+)$/);
                return match ? match[1] : null;
            }
        },
        backgroundOrigin: {
            label: 'Origin',
            type: 'select',
            options: ['border', 'padding', 'content'],
            default: 'padding',
            toClass: (value) => value ? `bg-origin-${value}` : null,
            fromClass: (className) => {
                const match = className.match(/^bg-origin-(.+)$/);
                return match ? match[1] : null;
            }
        }
    }
};
